export * from './thank.you.page.component'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/templates/thank.you.page/index.ts